export const environmentDEV = ['DEV', 'GCP_DEV'];

export const environmentSTAGE = ['STAGE', 'GCP_STAGE'];
